import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DateTime } from 'luxon';
import { AccountClient, UserLoginAzureDTO, UserLoginDTO } from '../models/models.swagger.generated';
import { LoginModel } from '../shared/login.model';

@Injectable()
export class LoginProxy {
    constructor(
        private accountClient: AccountClient) {
    }

    public login(data: LoginModel): Observable<[string, string, DateTime]> {
        return this.accountClient.tokenFromBody(new UserLoginDTO({userName: data.userName, password: data.password, twoFactorAuthenticationToken: data.twoFactorAuthenticationToken, grant_Type: 'password', client_Id: environment.apiClientId}))
          .pipe(
              map((res: any) => {
                  return [res.access_token, res.refresh_token, DateTime.now().plus({ seconds: res.expires_in })];
              })
        );
      }

    public loginWithAzureToken(): Observable<[string, string, DateTime]> {
        return this.accountClient.tokenWithAzurePrincipal(new UserLoginAzureDTO({clientId: environment.apiClientId, clientSecret: null}))
          .pipe(
              map((res: any) => {
                  return [res.access_token, res.refresh_token, DateTime.now().plus({ seconds: res.expires_in })];
              })
        );
      }
  
    public refreshTokenLogin(refreshToken: string): Observable<[string, string, DateTime]> {
    return this.accountClient.tokenFromBody(new UserLoginDTO({grant_Type: 'refresh_token', client_Id: environment.apiClientId, refresh_Token: refreshToken}))
        .pipe(
        map((res: any) => {
            return [res.access_token, res.refresh_token, DateTime.now().plus({ seconds: res.expires_in })];
        })
    );
    }
}
